import { formatPrice } from '../utils/formatPrice';

function CartBar({ totalCount, totalPrice, onToggleCart }) {
  return (
    <div className="cartBar" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <button className="cartLeft" type="button" onClick={onToggleCart} aria-label="打开购物车">
        <div className={`cartIcon ${totalCount > 0 ? 'active' : ''}`} aria-hidden="true">
          🛒
          {totalCount > 0 ? <span className="badge">{totalCount}</span> : null}
        </div>
        <div className="cartMeta">
          <div className="cartTotal">{formatPrice(totalPrice)}</div>
          <div className="cartTip">{totalCount > 0 ? '点击查看购物车' : '请选择菜品'}</div>
        </div>
      </button>
      <button className="checkout" type="button" disabled={totalCount <= 0}>
        去结算
      </button>
    </div>
  );
}

export default CartBar;
